import { useSortable } from '@dnd-kit/sortable';
import {
  IContainerWidget,
  ISortableWidgetData,
  Widget,
  isContainer,
  isRoot,
} from '@framework/engine';
import React from 'react';
import { InsertPositionIndicator } from './InsertPositionIndicator';
import { SortableWidgetRender } from './SortableWidgetRender';

export interface SortableWidgetProps {
  widget: Widget;
  parent: (Widget & IContainerWidget) | undefined;
}

/**
 * Container per la visualizzazione di un Widget durante la configurazione.
 * Include un pulsante per l'apertura della modal di configurazione.
 * e le funzionalità per l'ordinamento tramite drag and drop.
 */
export function SortableWidget(props: SortableWidgetProps) {
  const { widget, parent } = props;

  const sortableData: ISortableWidgetData = {
    path: widget.path,
    order: widget.order,
    type: widget.type,
  };

  const { attributes, listeners, setNodeRef, active, isOver, over } =
    useSortable({
      id: widget.id,
      data: sortableData,
    });

  // Attiva l'indicatore di drop se c'è un widget qui sopra e questo non è un container (in quel caso andrebbe _dentro_)
  // oppure se questo è il primo figlio di un container sopra cui si sta passando
  const showIndicator =
    (isOver && !(isContainer(widget) || isRoot(widget))) ||
    (over?.id === parent?.id &&
      // Se sono il primo figlio di un container
      parent?.children?.[0]?.id === widget.id);

  return (
    <div style={{ position: 'relative', margin: '0 -12px' }}>
      <div ref={setNodeRef} {...attributes} {...listeners}>
        <InsertPositionIndicator
          showIndicator={showIndicator}
          parent={parent}
        />

        <div style={{ padding: '0 12px', paddingTop: '6px' }}>
          <SortableWidgetRender
            widget={widget}
            parent={parent}
            isSpaceForDrag={widget.id === active?.id}
            isOverMe={isOver}
            isMoving={!!active?.id}
          />
        </div>
      </div>
    </div>
  );
}
